import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class HumanCapitalLeaveQuotaActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Hr/LeaveQuota/LeaveQuotaBrowser")
	}

	render() {
		return (
			<Activity 
				name="HumanCapitalLeaveQuota"
				RenderedComponent={this.RenderedComponent}
				context="HumanCapitalLeaveQuota"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(HumanCapitalLeaveQuotaActivity)
